import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'app/services/auth.service';
import { NotificationService } from 'app/services/models/notification.service';
import { UserService } from 'app/services/models/user.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-notificate-dialog',
  templateUrl: './create-notificate-dialog.component.html',
  styleUrls: ['./create-notificate-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateNotificateDialogComponent implements OnInit {
  @Input() id: number;

  notificationForm: FormGroup;
  users: any[] = [];

  titles: string[] = [
    "Kullanıcı Bildirimi",
    "Sistem Bildirimi",
    "Yeni Güncelleme",
    "Bakım Duyurusu",
    "Genel Duyuru"
  ];

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    public authService: AuthService,
    private userService: UserService,
    private notificationService: NotificationService) { }

  async ngOnInit() {
    this.notificationForm = this.fb.group({
      title: [null, Validators.required],
      description: [null],
      expireAt: [null],
      notificationType: [null, Validators.required],
      selectedUsers: [[]], // çoklu kullanıcı seçimi,
      resetReaders: [false],
      sendAllUsers: [true] // ✅ yeni eklenen checkbox
    });

    await this.getAllUsers();
    if (this.id !== null) {
      await this.getByIdNotification(this.id);
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  onSubmit() {
    if (this.notificationForm.invalid) return;

    const formValue = this.notificationForm.value;
    console.log(formValue);
    if (this.id) {
      const payload = {
        id: this.id,
        title: formValue.title,
        description: formValue.description,
        type: Number(formValue.notificationType),
        expireAt: formValue.expireAt ? new Date(formValue.expireAt) : null,
        appUserIds: formValue.sendAllUsers == true ? null : formValue.selectedUsers, // ng-select ile seçilen kullanıcılar
        hasReader: formValue.resetReaders
      };
      this.notificationService.updateNotification(payload).then(res => {
        if (res.status) {
          this.toastrService.success(res.message);
          this.notificationService.sendEvent(true);
          this.closeModal();
        } else {
          this.toastrService.error(res.message);
        }
      }).catch(err => {
        this.toastrService.error('Bildirim oluşturulamadı');
      });
    } else {
      const payload = {
        title: formValue.title,
        description: formValue.description,
        notificationType: Number(formValue.notificationType),
        expireAt: formValue.expireAt ? new Date(formValue.expireAt) : null,
        appUserIds: formValue.sendAllUsers == true ? null : formValue.selectedUsers, // ng-select ile seçilen kullanıcılar
      };

      console.log(payload);

      this.notificationService.createNotification(payload).then(res => {
        if (res.status) {
          this.toastrService.success(res.message);
          this.notificationService.sendEvent(true);
          this.closeModal();
        } else {
          this.toastrService.error(res.message);
        }
      }).catch(err => {
        this.toastrService.error('Bildirim oluşturulamadı');
      });
    }

  }

  async getAllUsers() {
    if (this.authService.isEndpointStatus('GET.Reading.GetUsers')) {
      const data = await this.userService.getAllUsers('', 0, 1000);
      console.log(data);
      this.users = data.users
        .filter(p => p.isActive)
        .map(p => ({
          id: p.id,
          fullName: p.personName + ' ' + p.personLastName
        }));
      const allUserIds = this.users.map(u => u.id);
      this.notificationForm.get('selectedUsers')?.setValue(allUserIds);
    }
  }


  async getByIdNotification(id) {
    const data = await this.notificationService.getByIdNotification(id);
    console.log(data);
    this.notificationForm.patchValue({
      title: data.title,
      description: data.description,
      expireAt: data.expireAt ? new Date(data.expireAt).toISOString().slice(0, 16) : null,
      notificationType: Number(data.type),
      selectedUsers: data.userNotifications.map(u => u.appUserId),
    });
    //this.hasReaders = data.userNotifications.some(u => u.isRead === true);
  }
}
